<!-- @prettier -->
<template>
	<div class="hours-operation__field">
		<div class="hours-operation__field-item display-flex flex--align-center">
			<label class="m-b-0">
				<strong>{{ day }}</strong>
			</label>

			<i
				v-if="closeTimeWarning"
				v-tooltip.top="$t('CONCURRENCY_SCHEDULE_WARNING_TT')"
				class="m-l-7 hours-operation__field-item-warning fa fa-exclamation-circle"
				aria-hidden="true"
			/>

			<i
				v-if="sameTimeWarning"
				v-tooltip.top="sameTimeWarningMessage"
				class="m-l-7 hours-operation__field-item-warning fa fa-exclamation-circle"
				aria-hidden="true"
			/>

			<div class="hours-operation__day-toggle">
				<nzToggle
					v-if="hoursType == 'advanced'"
					v-model="isOpenStatus"
					@onToggle="updateOpenStatus"
					:disabled="disabled"
				/>
			</div>
		</div>
		<div class="hours-operation__field-item">
			<div class="hours-operation__time-input-wrapper">
				<input
					class="form-control hours-operation__time-input"
					type="time"
					aria-label="Open Time"
					:value="openTime"
					:disabled="disabled || !isOpen"
					@change="updateOpenTime($event.target.value)"
				/>
			</div>
		</div>
		<div class="hours-operation__field-item">
			<div class="hours-operation__time-input-wrapper">
				<input
					class="form-control hours-operation__time-input"
					type="time"
					aria-label="Close Time"
					:value="closeTime"
					:disabled="disabled || !isOpen"
					@change="updateCloseTime($event.target.value)"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import moment from 'moment';
import nzToggle from '@/core/components/nzToggle/nzToggle';

export default {
	name: 'HoursOfOperationTimeValues',
	components: {
		nzToggle
	},
	props: {
		hoursType: {
			type: String,
			default: 'basic'
		},
		openTime: {
			type: String,
			default: '12:00'
		},
		closeTime: {
			type: String,
			default: '24:00'
		},
		day: {
			type: String,
			default: 'Sun - Sat'
		},
		isOpen: {
			type: Boolean,
			default: true
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			isOpenStatus: this.isOpen
		};
	},
	computed: {
		closeTimeWarning() {
			return moment(this.openTime, 'HH:mm').isAfter(
				moment(this.closeTime, 'HH:mm')
			);
		},
// BEGIN: NEW COMPUTED PROPERTY FOR SAME TIME WARNING
        sameTimeWarning() {
			return this.openTime === this.closeTime;
		},
		sameTimeWarningMessage() {
			return this.hoursType === 'basic'
				? this.$t('SAME_TIME_SCHEDULE_WARNING_BASIC_TT')
				: this.$t('SAME_TIME_SCHEDULE_WARNING_ADVANCED_TT');
		}
	},
	methods: {
		updateOpenTime(value) {
			this.$emit('update:open-time', value);
		},
		updateCloseTime(value) {
			this.$emit('update:close-time', value);
		},
		updateOpenStatus(value) {
			this.$emit('update:is-open', value);
		}
	}
};
</script>
